<template>
  <span class="number-formatted">
    <span v-if="+number === 0">–</span>
    <span v-else  v-for="part in parts" v-text="part"/>
    <span v-if="currencySymbol && +number !== 0"> {{ currencySymbol }}</span>
  </span>
</template>

<script>
  import isNaN from 'lodash/isNaN'

  export default {
    name: 'number',
    props: {
      number: {required: true},
    },
    computed: {
      parts () {
        return this.formatNumber(this.number).split('\u00A0') // split by nbsp
      },
    },
    methods: {
      formatNumber (number) {
        const value = parseFloat(number)
        return isNaN(value) ? '' : value.toLocaleString('ru')
      },
    },
  }
</script>

<style lang="scss">
  .number-formatted {
    :not(:first-child) {
      margin-left: .2em;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/number.vue